export const MAX_WIDTH = '1440px';
export const PRIMARY_CONTENT_MIN_WIDTH_PX = '400px';
export const SECONDARY_CONTENT_MAX_WIDTH_PX = '450px';
export const PRIMARY_SMALL_CONTENT_MIN_WIDTH_PX = '300px';
export const SECONDARY_SMALL_CONTENT_BASIS = '150px';
export const LAYOUT_PRIMARY_CONTENT_BASIS = '200px';
export const LAYOUT_SECONDARY_CONTENT_BASIS = '406px';
export const LAYOUT_SECONDARY_CONTENT_BASIS_SMALL = '150px';
export const LAYOUT_BREAKPOINT_MEDIUM = '768px';
export const GUIDANCE_MODAL_WIDTH = 886;
export const GUIDANCE_IMAGE_HEIGHT_PX = '128px';
export const GUIDANCE_MODAL_BUTTON_WIDTH_PX = '242px';